import { MIN_UNITS_B2B, PRICE_PER_UNIT_FROM } from "@/data/pricing";

type PriceAnchorProps = {
  pricePerUnit?: number | null;
  minUnits?: number;
};

/**
 * Ancla de precio público de la home B2B.
 *
 * Muestra un rango "desde $X por unidad a partir de N unidades". Sin valor de
 * precio (aún sin definir por el negocio) degrada a mostrar solo el mínimo. El
 * detalle por tramos NO se publica aquí: va dentro del catálogo gateado.
 */
export const PriceAnchor = ({
  pricePerUnit = PRICE_PER_UNIT_FROM,
  minUnits = MIN_UNITS_B2B,
}: PriceAnchorProps) => (
  <div className="mb-8 md:mb-9">
    <p className="text-lg md:text-xl font-semibold text-brown-dark">
      {pricePerUnit != null
        ? `desde $${pricePerUnit} por unidad a partir de ${minUnits} unidades`
        : `desde ${minUnits} unidades`}
    </p>
    <p className="text-sm text-brown-light/80 mt-1">
      Precio referencial. La cotización en firme la confirma Vivi.
    </p>
  </div>
);

export default PriceAnchor;
